// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FrownTwoToneSvg from "@fishx/icons-svg/es/asn/FrownTwoTone";
import FishxIcon from '../components/FishxIcon';

var FrownTwoTone = function FrownTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FrownTwoToneSvg
  }));
};

FrownTwoTone.displayName = 'FrownTwoTone';
export default React.forwardRef(FrownTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FrownTwoTone.js
// module id = 2840
// module chunks = 0